// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_l0-0";
export var fileCarousel = "_l0-2";
export var removeFileButton = "_l0-1";